var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 16.6667L9.99967 10L16.6663 3.33334",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 8.33333C7.0275 8.33333 8.33333 7.0275 8.33333 5.41667C8.33333 3.80583 7.0275 2.5 5.41667 2.5C3.80583 2.5 2.5 3.80583 2.5 5.41667C2.5 7.0275 3.80583 8.33333 5.41667 8.33333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5837 17.5C16.1945 17.5 17.5003 16.1942 17.5003 14.5833C17.5003 12.9725 16.1945 11.6667 14.5837 11.6667C12.9728 11.6667 11.667 12.9725 11.667 14.5833C11.667 16.1942 12.9728 17.5 14.5837 17.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentOutline);
export default __webpack_public_path__ + "static/media/percent-outline.03a1b784c5684899a76c1defdccb2ad4.svg";
export { ForwardRef as ReactComponent };